import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GSCDataSet, ParsedData } from '@taptimize/shared';

@Injectable({ providedIn: 'root' })
export class DataStoreService {
  private dataSubject = new BehaviorSubject<ParsedData | null>(null);
  public data$ = this.dataSubject.asObservable();

  setData(datasets: GSCDataSet[], zipFilename: string) {
    const parsedData: ParsedData = {
      datasets,
      zipFilename,
      uploadedAt: new Date()
    };
    this.dataSubject.next(parsedData);
  }

  getData(): ParsedData | null {
    return this.dataSubject.value;
  }

  clearData() {
    this.dataSubject.next(null);
  }
} 